import { useNavigate, useParams } from 'react-router-dom'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface BlockSendSurveyModalProps {
  trainingId?: string
  formId?: string
  onClose?: () => void
}

const BlockSendSurveyModal = ({
  trainingId: propTrainingId,
  formId: propFormId,
  onClose: propOnClose,
}: BlockSendSurveyModalProps = {}) => {
  const navigate = useNavigate()
  const params = useParams<{ id: string; formId: string }>()

  // Use props if provided, otherwise fall back to URL params
  const id = propTrainingId ?? params.id
  const formId = propFormId ?? params.formId

  const { navigation } = useNavigation()

  const onCloseRoute =
    navigation.trainings.list.details_revamp.trainingSurveyDetail.questions.fullPath({
      id: String(id),
      formId: String(formId),
    })

  return (
    <Modal
      title={i18n.t('trainings.surveys.create.blocked_send_survey.title')}
      description={i18n.t('trainings.surveys.create.blocked_send_survey.description')}
      illustration="document-edit"
      onClose={propOnClose ?? (() => navigate(onCloseRoute))}
    />
  )
}

export default BlockSendSurveyModal
